import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Z_INDEXES} from '../../../constants/layers';

export const overlayWrapperCss = css`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${Z_INDEXES.TADARIDA_FULLSCREEN_SLIDER_WRAPPER};
  background-color: ${COLORS.White};
`;

export const OverlayWrapper = styled.div<{$isOpen: boolean}>`
  ${({$isOpen}) =>
    $isOpen
      ? overlayWrapperCss
      : css`
          background-color: ${COLORS.White};
        `}
`;
